import { LOAD_CART, ADD_PRODUCT, REMOVE_PRODUCT, CHANGE_PRODUCT_QUANTITY } from './actionTypes';

export const loadCart = products => ({
    type: LOAD_CART,
    payload: products
});

export const addProduct = product => dispatch => {
    dispatch({
        type: ADD_PRODUCT,
        payload: product
    })
};

export const removeProduct = product => ({
    type: REMOVE_PRODUCT,
    payload: product
});

export const changeProductQuantity = product => ({
    type: CHANGE_PRODUCT_QUANTITY,
    payload: product
});


// WEBPACK FOOTER //
// ./src/components/Cart/Actions/CartActions.js